import { Button, Modal, Row } from 'antd';
import React, { useImperativeHandle, forwardRef, useState } from 'react';
import Label from '../../elements/Label';

export default forwardRef((_, ref) => {
  const [modalOpen, setModalOpen] = useState(false);

  const toggleOpen = (open) => {
    if(modalOpen !== open) {
      setModalOpen(open);
    }
  };

  useImperativeHandle(ref, () => ({
    toggleOpen,
  }));

  return (
    <Modal
        title='Terms of Use'
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onCancel={() => setModalOpen(false)}
        width={'450px'}
        bodyStyle={{ padding: '16px', zIndex: 990 }}
        style={{ zIndex: 1000 }}
        footer={false}
        centered
    >
        <Label labelType="Body1" caption='By logging in and accessing bettercommunity.ca, you agree that the use of our website and its contents, are entirely at your own risk.' style={{ paddingTop: '16px' }} /><br /><br />

        <Label labelType='Body2' caption="Although we will do our best, we cannot guarantee any of the following:" /><br />
        <ul >
            <li>our website content is accurate, complete, reliable, or suitable,</li>
            <li>our website will be uninterrupted or error-free,</li>
            <li>the quality or content of third-party links to other websites,</li>
            <li>that we will correct all defects or errors,</li>
            <li>and our website will be free from viruses or harmful components.</li>
        </ul>
        <Row>
            <Button type='primary' style={{ marginTop: '16px', float: 'right' }} onClick={() => setModalOpen(false)} >Close</Button>
        </Row>
    </Modal>
  );
})